module.exports = __webpack_public_path__ + "public/img/gzh.456dd257.jpg";